export const wrapper = () => ({
    padding: '40px 30px',
});
